/**
 * Optional deep-link flag (`?create=1`) so Create Design can open on any page.
 * Consumed by CreateDesignProvider. A nonce lets a second intent change the URL
 * after the first was stripped.
 */

export const CREATE_DESIGN_QUERY_KEY = "create";
export const CREATE_DESIGN_QUERY_VALUE = "1";
export const CREATE_DESIGN_NONCE_KEY = "t";

export function buildCreateDesignSearch(nonce) {
  const params = new URLSearchParams();
  params.set(CREATE_DESIGN_QUERY_KEY, CREATE_DESIGN_QUERY_VALUE);
  params.set(
    CREATE_DESIGN_NONCE_KEY,
    String(nonce ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`)
  );
  return `?${params.toString()}`;
}

export function hasCreateDesignIntent(searchParams) {
  return searchParams?.get?.(CREATE_DESIGN_QUERY_KEY) === CREATE_DESIGN_QUERY_VALUE;
}

export function stripCreateDesignIntent(searchParams) {
  const next = new URLSearchParams(searchParams);
  next.delete(CREATE_DESIGN_QUERY_KEY);
  next.delete(CREATE_DESIGN_NONCE_KEY);
  return next;
}
